/* eslint-disable no-mixed-spaces-and-tabs */
import Vue from "vue";
import uuid from "uuid";
import { mapActions } from "vuex";
import { CompanyService, FieldsService } from "smck-service";
import PortalCompanyService from "../../../service/company-service";
import { zLanguageChanger } from "zoox-components";
import sessionMixin from "@/components/shared/mixins/sessionMixin";

export default {
  name: "CardView",
  mixins: [sessionMixin],
  components: {
    "z-language-changer": zLanguageChanger
  },
  data() {
    return {
      hasSide: true,
      loading: false,
      paramsReady: false,
      companyId: "",
      currentCompany: {},
      customizationSettings: {},
      fieldSettingsData: {},
      additionalData: {},
      companyParams: {},
      fieldsService: new FieldsService(Vue),
      companyService: new CompanyService(Vue),
      oldCompanyService: new PortalCompanyService()
    };
  },
  mounted: async function() {
    if (typeof this.$route.meta.hasSide !== "undefined") {
      this.hasSide = this.$route.meta.hasSide;
    }

    // eslint-disable-next-line no-warning-comments
    const company = this.oldCompanyService.getLocalCompany();

    if (company && company.id) {
      this.currentCompany = company;

      this.companyId = company.id;

      this.customizationSettings = this.companyService.getLocalCustomizationSettings();

      this.fieldSettingsData = await this.fieldsService.getFormattedFields(
        this.companyId
      );

      this.additionalData = await this.fieldsService.getAdditionalData(
        this.companyId
      );

      this.companyParams = await this.companyService.getFnrhFormSettings(
        this.companyId
      );

      this.paramsReady = true;
    }
  },
  created() {
    // sempre que entramos na tela, damos scroll para o topo
    // pois por vezes o scroll vem alterado da tela anterior
    $(document).ready(function() {
      $(this).scrollTop(0);
    });
  },
  methods: Object.assign(
    {
      getLogoUrl: function() {
        return this.customizationSettings.portalLogoUrl
          ? this.customizationSettings.portalLogoUrl + `?unique=${uuid.v4()}`
          : require("@/assets/images/logo-smart.png");
      }
    },
    mapActions(["$setIsRec", "$setGuestDocumentData"])
  )
};
